import React,{useState,useEffect} from 'react';
import { Link ,useNavigate } from "react-router-dom";
import NavDropdown from 'react-bootstrap/NavDropdown';
import Helpers from "../Helpers/Custom";
import  Config from '../Helpers/Config';

function Sidepanel({showSidebar,setParent,userInfo,landingPage},props) {
    const navigate = useNavigate();
     const [showBar, setShowBar] = useState(false);
     const [localConfig, setLocalConfig] = useState(null);


     useEffect(() => {
        setShowBar(showSidebar);
        setLocalConfig(JSON.parse(localStorage.getItem("userInfo")))
        document.body.addEventListener('click', toggleSidebar );
     }, [showSidebar]);
     

    const toggleSidebar = ()=>{
        setShowBar(false);
        setParent(false)
    }

   const onClickProhibit = (e)=>{
         e.stopPropagation();
    }

    const changePassword = ()=>{
        window.location.replace("/change-password");
    }

    const logout = ()=>{
        navigate("/logout");
    }

 
    return (
        <div className={showBar ? "sidePanelConatiner showsideBar" : "sidePanelConatiner"}>
            {/* <div className="sidebar-backdrop"></div> */}
            <div id="mySidepanel" className="sidepanel">
              <div id="sidebar" className={showBar ? "showsideBar" : ""}>
				<div id="sidebar-head">
					<div className="user-details clearfix" onClick={onClickProhibit}>
                    {/* {Helpers.isMobile() &&
                                                <div className="ms-3" id="header">
                                                    <a href={"/"+landingPage} className="homeLink"> <img src={"https://assets.investera.com/investera-client-configs/clients/"+Config.provider+"/logo.png"} width="100" title="" /></a>
                                                </div>
                                                } */}
                    <NavDropdown title={<React.Fragment >
                                            <i class="fa fa-user-circle userIcon"></i>
                                            <span className="title-profile">{userInfo?.login}<i className="caret caretBlue"></i></span>
                                        </React.Fragment>} 
                                        id="preferences-dropdown" className="d-flex-center">
                            <NavDropdown.Item onClick={onClickProhibit}>
                                         <a href="/change-password" className="pointer ddOption" onClick={changePassword}>
                                                <i className="material-icons">verified_user</i>
                                                <span >Change password</span>
                                            </a>
                            </NavDropdown.Item>
                            <NavDropdown.Item  onClick={onClickProhibit}>
                                   <a className="pointer logoutBtn ddOption" onClick={logout}>
                                                <i className="material-icons">exit_to_app</i>
                                                <span >Logout</span>
                                            </a>
                            </NavDropdown.Item>

                    </NavDropdown>
                    <a className="pointer float-end sidePanelClose" onClick={toggleSidebar}><i className="fa fa-times"></i></a>
					</div>
				</div>
				<div id="sidebar-body">
                    <nav className="main-nav">
                        <ul className="list-unstyled">
                            <li>
                                <a href={"/"+landingPage} className="homeLink" state={{"pageName":"Dashboard"}}>
                                    <i className="material-icons">home</i>
                                    <span>Home</span>
                                </a>
                            </li>
                           {localConfig && localConfig.clientConfig && localConfig?.clientConfig && localConfig?.clientConfig?.name?.toLowerCase() == 'dimah' && <li className="portfolioField">
                                <a href="/portfolio-summary">
                                    <i className="material-icons">shopping_bag</i>
                                    <span>Portfolio Summary</span>
                                </a>
                            </li>}

                            <li>
                                <Link to="/documents" state={{"pageName":"Documents"}}>
                                    <i className="material-icons">description</i>
                                    <span>Documents</span>
                                </Link>                    
                            </li>
                            
                            <li>
                                <Link to="/vdr" state={{"pageName":"VDR"}}>
                                    <i className="material-icons">vpn_key</i>
                                    <span>Virtual Data Room</span>
                                </Link>                    
                            </li>
                            
                            <li>
                                <Link to="/reports" state={{"pageName":"Reports"}}>
                                    <i className="material-icons">short_text</i>
                                    <span>Reports</span>
                                </Link>                    
                            </li>
                            
                            <li>
                                <Link to="/forms" state={{"pageName":"Forms"}}>
                                    <i className="material-icons">content_copy</i>
                                    <span>Forms</span>
                                </Link>                    
                            </li>
                            
                            <li>
                                <a href="/uploaded-documents">
                                    <i className="material-icons">cloud_upload</i>
                                    <span>Uploaded Documents</span>
                                </a>                    
                            </li>
                        
                            <li>
                                <a href="/notifications" state={{"pageName":"Notifications"}}>
                                    <i className="material-icons">notifications</i>
                                    <span>Notifications</span>
                                </a>                    
                            </li> 
                            {/* <li>
                                <a >
                                    <i className="material-icons">settings</i>
                                    <span>Settings</span>
                                </a>                    
                            </li>   */}
                            {/* <li>
                                <a >
                                    <i className="material-icons">logout</i>
                                    <span>Logout</span>
                                </a>                    
                            </li>  */}
                        </ul>
                    </nav>
		       </div>
		     </div>
            </div>
        </div>
    )
}

export default Sidepanel
